import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], term: any): any[] {
    if(!items) return [];
    if(!term) return items;
    term = term.toString().toLowerCase();
    return items.filter( it => {
      return it.model.toString().toLowerCase().includes(term);
    });
  }

}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/filter.pipe.ts